import { render, staticRenderFns } from "./ProviderEditCreate.vue?vue&type=template&id=13cbbef7&scoped=true&"
import script from "./ProviderEditCreate.vue?vue&type=script&lang=js&"
export * from "./ProviderEditCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cbbef7",
  null
  
)

export default component.exports